import { chatMsgReducer } from "./chat-msg-reducer";
import { chatCommonReducer } from "./chat-common-reducer";
import { ChatCommonState } from "../types/common-types";
import { chatSuggestionReducer } from "../reducers/chat-suggestion-reducer";
import {ChatMsgState} from "../types/chat-msg-types";
import { combineReducers } from "redux";
import { ChatSuggestionState } from "../types/chat-suggestion-types";
import { chatAuthenticationReducer } from "../reducers/chat-authentication-reducer";
import { ChatAuthenticationState } from "../types/chat-authentication-types";
import {chatSettingReducer} from "./chat-setting-reducer";
import {ChatSettingState} from "../types/chat-setting-types";


export interface AppRootState {
    chatMsg: ChatMsgState;
    chatCommon: ChatCommonState;
    chatSuggestionReducer: ChatSuggestionState;
    chatAuthenticationReducer: ChatAuthenticationState;
    chatSettingReducer:ChatSettingState;
}

const rootReducer = combineReducers({
    chatMsg: chatMsgReducer,
    chatSuggestionReducer: chatSuggestionReducer,
    chatCommon: chatCommonReducer,
    chatAuthenticationReducer: chatAuthenticationReducer,
    chatSettingReducer:chatSettingReducer
});

export default rootReducer;
